/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

/**
 * The different sex options
 */
// eslint-disable-next-line no-shadow
enum Sexe {
  Homme = 'homme',
  Femme = 'femme',
  Indetermine = 'indetermine',
}

export default Sexe;
